<template lang="html">
<div class="add-coupon sl-coupon" >
  <row>
    <div class="sl-col-4">
      <div class="sl-coupon-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="title"><i @click="goBack()">< {{$t('Views.AddCoupon.type')}}</i>{{$route.query.name}}</div>
            <div class="form">
              <el-form :model="form" label-width="100px">
                <el-form-item :label="$t('Views.AddCoupon.f1')" prop="discount" class="form-font" v-if="$route.query.id === '1'">
                  <span>{{$tc('Views.AddCoupon.t1f1',1)}}</span>
                  <el-input type="number" v-model.number="form.discount" auto-complete="off" style="width:100px"  @change="handleChange" :class="{'sl-input-danger': form.discount === '' || showErr}" :maxlength="maxlength">
                    <template slot="append">%</template>
                  </el-input>
                  <span>{{$tc('Views.AddCoupon.t1f1',2)}}</span>
                  <p class="sl-cp-error" v-show="showErr">{{errorMsg}}</p>
                </el-form-item>

                <el-form-item :label="$t('Views.AddCoupon.f1')" prop="discount" class="form-font" v-else-if="$route.query.id === '2'">
                  <el-input type="number" v-model.number="form.discountPrice" auto-complete="off" style="width:100px"  @change="handleChange" :class="{'sl-input-danger': form.discountPrice === '' || showErr}">
                    <template slot="prepend">{{$store.state.theme.companyInfo.currency}}</template>
                  </el-input>
                  <span>{{$tc('Views.AddCoupon.t2f1',1)}}</span>
                  <el-input type="number" v-model.number="form.minSpending" auto-complete="off" style="width:120px"  @change="handleChange" :class="{'sl-input-danger': form.minSpending === '' || showErr}">
                    <template slot="prepend">{{$store.state.theme.companyInfo.currency}}</template>
                  </el-input>
                  <span>{{$tc('Views.AddCoupon.t2f1',2)}}</span>
                  <p class="sl-cp-error" v-show="showErr">{{errorMsg}}</p>
                </el-form-item>

                <el-form-item :label="$t('Views.AddCoupon.f1')" prop="discount" class="form-font" v-else-if="$route.query.id === '3'">
                  <el-input type="number" v-model.number="form.discount" auto-complete="off" style="width:100px"  @change="handleChange" :class="{'sl-input-danger': form.discount === '' || showErr}">
                    <template slot="append">%</template>
                  </el-input>
                  <span>{{$tc('Views.AddCoupon.t2f1',1)}}</span>
                  <el-input type="number" v-model.number="form.minSpending" auto-complete="off" style="width:100px"  @change="handleChange" :class="{'sl-input-danger': form.minSpending === '' || showErr}">
                    <template slot="prepend">{{$store.state.theme.companyInfo.currency}}</template>
                  </el-input>
                  <span>{{$tc('Views.AddCoupon.t2f1',2)}}</span>
                  <p class="sl-cp-error" v-show="showErr">{{errorMsg}}</p>
                </el-form-item>


                <el-form-item :label="$t('Views.AddCoupon.f2')" prop="name">
                  <el-select v-model="form.nameId" filterable :placeholder="$t('Views.AddCoupon.placeholder')" style="width:80%;">
                    <el-option
                      v-for="item in CouponOP"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('Views.AddCoupon.f3')" prop="age" class="form-font">
                  <el-radio-group v-model="form.month">
                    <el-radio label="1">{{$tc('Views.AddCoupon.month',1)}}</el-radio>
                    <el-radio label="3">{{$tc('Views.AddCoupon.month',2)}}</el-radio>
                  </el-radio-group>
                </el-form-item>

              </el-form>
            </div>
            <div class="rules">
              <span>{{$t('Views.AddCoupon.rules')}}</span>
              <ul>
                <li v-for="item in rules">{{item}}.</li>
              </ul>
            </div>

            <div class="btn-list">
              <el-button @click="goBack">{{$t('Functional.cancel')}}</el-button>
              <el-button type="success" @click="handlePublish" :disabled="btnDisabled">{{$t('Functional.publish')}}</el-button>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="use"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </row>

  <el-dialog v-model="couponDialog" >
    <p class="coupon-name">{{r1}}</p>
    <p class="coupon-time">{{time}}</p>
    <img class="coupon-img" src="../../assets/imgs/qrcode.png" alt="">
    <div slot="footer" class="dialog-footer">
      <p>{{$t('Views.AddCoupon.tip')}}</p>
      <el-button class="coupon-btn" @click="couponDialog = false">{{$t('Functional.cancel')}}</el-button>
      <el-button class="coupon-btn" @click="publish" :loading="loading" >{{$t('Functional.confirm')}}</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import api from '../../api'
import moment from 'moment'
export default {
  created() {
    const vm = this
    api.FetchCouponNameById({
      typeId: this.$route.query.id,
      lang: this.$store.state.user.userinfo.lang !== '' ? this.$store.state.user.userinfo.lang : 'en'
    }).then(res => {
      if (res.data.code === 200) {
        vm.defaultOP = vm.createArr(res.data.data)
        vm.CouponOP = vm.formatCoupon(vm.$route.query.id, res.data.data)
        vm.form.nameId = vm.CouponOP[0].id
      }
    })
  },
  computed: {
    r1() {
      if (this.$route.query.id === '1') {
        this.form.minSpending = ''
        this.form.discountPrice = ''
        return `Storewide ${this.form.discount}% Off`
      } else if (this.$route.query.id === '2') {
        this.form.discount = ''
        return `${this.$store.state.theme.companyInfo.currency} ${this.form.discountPrice} Off with ${this.$store.state.theme.companyInfo.currency} ${this.form.minSpending} Spend`
      } else if (this.$route.query.id === '3') {
        this.form.discountPrice = ''
        return `${this.form.discount}% Off with ${this.$store.state.theme.companyInfo.currency} ${this.form.minSpending} Spend`
      }
    },
    time() {
      const month = this.form.month === '1' ? 1 : 3
      return `${moment(new Date()).format('YYYY.MM.DD')} - ${moment(new Date()).add(month, 'months').format('YYYY.MM.DD')}`
    },
    rules() {
      return [
        this.$t('Views.AddCoupon.r1') + ' ' + this.r1,
        this.$t('Views.AddCoupon.r2') + this.time,
        this.$t('Views.AddCoupon.r3'),
        this.$t('Views.AddCoupon.r4'),
        this.$t('Views.AddCoupon.r5'),
        this.$t('Views.AddCoupon.r6')
      ]
    }
  },
  data() {
    return {
      btnDisabled: false,
      maxlength: 2,
      loading: false,
      couponDialog: false,
      form: {
        month: '1',
        discount: 10,
        nameId: '',
        typeId: this.$route.query.id,
        minSpending: 100,
        discountPrice: 10
      },
      type: {},
      CouponOP: [],
      defaultOP: [],
      showErr: false,
      errorMsg: ''
    }
  },
  methods: {
    publish() {
      this.$ga.event('Button', 'Publish', 'Add coupon')
      const vm = this
      this.loading = true
      api.PublishCoupon(this.form).then(res => {
        if (res.data.code === 200) {
          vm.$router.push({
            name: 'Coupon-List',
            query: {
              new: 1
            }
          })
        } else {
          vm.$notify.error({
            title: 'fail',
            message: res.data.msg
          })
        }
      })
    },
    goBack() {
      this.$ga.event('Link', 'Back', 'Add coupon')
      this.$router.back()
    },
    createArr(arr) {
      return JSON.parse(JSON.stringify(arr))
    },
    handleChange(val) {
      if (this.$route.query.id === '1') {
        if (this.form.discount === '') {
          this.btnDisabled = true
        } else {
          this.btnDisabled = false
          this.showErr = false
        }
      } else if (this.$route.query.id === '2') {
        if (this.form.minSpending === '' || this.form.discountPrice === '') {
          this.btnDisabled = true
        } else {
          this.btnDisabled = false
          this.showErr = false
        }
      } else if (this.$route.query.id === '3') {
        if (this.form.minSpending === '' || this.form.discount === '') {
          this.btnDisabled = true
        } else {
          this.btnDisabled = false
          this.showErr = false
        }
      }
      this.CouponOP = this.formatCoupon(this.$route.query.id, this.createArr(this.defaultOP))
    },
    handlePublish() {
      if (this.$route.query.id === '1') {
        if (this.form.discount === '') {
          this.btnDisabled = true
        } else if (!Number.isInteger(this.form.discount)) {
          // this.$message.error(this.$t('Views.AddCoupon.msg1'))
          this.errorMsg = this.$t('Views.AddCoupon.msg1')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (this.form.discount > 99 || this.form.discount < 1) {
          // this.$message.error(this.$t('Views.AddCoupon.msg2'))
          this.errorMsg = this.$t('Views.AddCoupon.msg2')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (/^(1|99|\d{1,2})$/.test(this.form.discount)) {
          this.showErr = false
          this.btnDisabled = false
        }
      } else if (this.$route.query.id === '2') {
        if (this.form.minSpending === '' || this.form.discountPrice === '') {
          this.btnDisabled = true
        } else if (this.form.minSpending > 10000) {
          // this.$message.error(this.$t('Views.AddCoupon.msg3'))
          this.errorMsg = this.$t('Views.AddCoupon.msg3')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (this.form.minSpending <= 0) {
          // this.$message.error(this.$t('Views.AddCoupon.msg4'))
          this.errorMsg = this.$t('Views.AddCoupon.msg4')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (this.form.discountPrice <= 0) {
          // this.$message.error(this.$t('Views.AddCoupon.msg5'))
          this.errorMsg = this.$t('Views.AddCoupon.msg5')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (!Number.isInteger(this.form.minSpending)) {
          // this.$message.error(this.$t('Views.AddCoupon.msg6'))
          this.errorMsg = this.$t('Views.AddCoupon.msg6')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (!Number.isInteger(this.form.discountPrice)) {
          // this.$message.error(this.$t('Views.AddCoupon.msg7'))
          this.errorMsg = this.$t('Views.AddCoupon.msg7')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (this.form.discountPrice >= this.form.minSpending) {
          // this.$message.error(this.$t('Views.AddCoupon.msg8'))
          this.errorMsg = this.$t('Views.AddCoupon.msg8')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else {
          this.showErr = false
          this.btnDisabled = false
        }
      } else if (this.$route.query.id === '3') {
        if (this.form.minSpending === '' || this.form.discount === '') {
          this.btnDisabled = true
        } else if (this.form.minSpending > 10000) {
          // this.$message.error(this.$t('Views.AddCoupon.msg3'))
          this.errorMsg = this.$t('Views.AddCoupon.msg3')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (this.form.minSpending <= 0) {
          // this.$message.error(this.$t('Views.AddCoupon.msg4'))
          this.errorMsg = this.$t('Views.AddCoupon.msg4')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (!Number.isInteger(this.form.minSpending)) {
          // this.$message.error(this.$t('Views.AddCoupon.msg6'))
          this.errorMsg = this.$t('Views.AddCoupon.msg6')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (!Number.isInteger(this.form.discount)) {
          // this.$message.error(this.$t('Views.AddCoupon.msg1'))
          this.errorMsg = this.$t('Views.AddCoupon.msg1')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else if (this.form.discount > 99 || this.form.discount < 1) {
          // this.$message.error(this.$t('Views.AddCoupon.msg2'))
          this.errorMsg = this.$t('Views.AddCoupon.msg2')
          this.showErr = true
          this.btnDisabled = false
          return false
        } else {
          this.showErr = false
          this.btnDisabled = false
        }
      }
      this.couponDialog = true
    },
    formatCoupon(id, arr) {
      const vm = this
      if (id === '1') {
        arr.map(item => {
          Object.assign(item, {
            name: item.name.replace('_X', vm.form.discount).replace('&Merchant Name', vm.$store.state.user.userinfo.merchantName)
          })
        })
      } else if (id === '2') {
        arr.map(item => {
          Object.assign(item, {
            name: item.name.replace('_A', vm.form.minSpending).replace('_S', vm.form.discountPrice).replace('&Merchant Name', vm.$store.state.user.userinfo.merchantName)
          })
        })
      } else if (id === '3') {
        arr.map(item => {
          Object.assign(item, {
            name: item.name.replace('_A', vm.form.minSpending).replace('_X', vm.form.discount).replace('&Merchant Name', vm.$store.state.user.userinfo.merchantName)
          })
        })
      }
      return arr
    }
  }
}
</script>
<style>
.add-coupon .use {
  width: 100%;
  height: 500px;
  background-image: url(../../assets/imgs/coupon_use.png);
  background-size: contain;
  background-repeat: no-repeat;
}

.add-coupon .form {
  background-image: url(../../assets/imgs/coupon_form.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 20px;
}

.add-coupon .form .el-form {
  position: relative;
  top: 15px;
}

.add-coupon .form-font {
  font-family: Avenir-Book;
  font-size: 13px;
  color: #000000;
  letter-spacing: 0;
  line-height: 16px;
}

.add-coupon .form-font .el-form-item__content>span {
  display: inline-block;
  padding: 0 10px;
}

@media only screen and (max-width: 768px) {
  .add-coupon .el-form-item>label {
    display: block;
    width: 100% !important;
    text-align: left;
  }
  .add-coupon .el-form-item .el-form-item__content {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
  .add-coupon div.rules>ul {
    padding-left: 10px;
    position: static;
  }
}

.add-coupon .el-radio__label {
  font-weight: normal;
  font-family: Avenir-Book;
  font-size: 13px;
  color: #000000;
  letter-spacing: 0;
  line-height: 23px;
}

.add-coupon .el-form-item__content {
  padding-left: 20px;
}

.add-coupon .rules {
  font-family: Avenir-Book;
  font-size: 13px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 22px;
  margin-top: 30px;
  padding-bottom: 20px;
}

.add-coupon .rules>ul {
  display: inline-table;
  position: relative;
  left: -30px;
}

.add-coupon .rules>span {
  font-family: Avenir-Medium;
  font-size: 13px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 13px;
  position: relative;
  left: 10px;
  display: block;
}

.add-coupon .btn-list {
  padding-top: 20px;
  border-top: 2px solid #D8D8D8;
  text-align: center;
  width: 100%;
}

.add-coupon .el-dialog__header {
  display: none;
}

.add-coupon .el-dialog {
  width: 260px;
  height: 300px;
  background: #FFFFFF;
  border-radius: 6px;
}

.coupon-name {
  font-family: Arial-BoldMT;
  font-size: 22px;
  color: #2B90E9;
  letter-spacing: 0;
  line-height: 32px;
  text-align: center;
}

.coupon-time {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 13px;
  text-align: center;
}

.add-coupon .el-dialog__footer {
  text-align: center;
  position: relative;
  top: 120px;
  width: 500px;
  left: -120px;
}

.add-coupon .dialog-footer>p {
  font-family: Avenir-Book;
  font-size: 22px;
  color: #FFFFFF;
  letter-spacing: 0;
  width: 400px;
  position: absolute;
  left: 50%;
  margin-left: -200px;
  top: -40px;
}

.coupon-img {
  width: 100px;
  height: 100px;
  position: relative;
  left: 50%;
  margin-left: -50px;
  top: 40px;
}

.coupon-btn {
  border: 1px solid #D7D7D7;
  border-radius: 2px;
  font-family: Avenir-Medium;
  font-size: 15px;
  color: #CCCCCC;
  letter-spacing: 0;
  padding: 8px 20px;
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
  height: 40px;
}

.el-button.coupon-btn {
  background: none;
  margin: 0 5px;
  height: 40px;
  display: inline-block;
}

.sl-cp-error {
  color: red;
  font-size: 12px;
  line-height: 12px;
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// add-coupon.vue?998563e4